export default {
  checkedBlockPrices: [],
  blockPrices: [],
  selectedBlockPriceModel: null,
  impactedParks: ''
}
